import * as XLSX from 'xlsx'
import type { Job, Order } from '@/types'

/**
 * Designer Excel export - replicates the name & number block of the client's
 * production Excel (KERIAN-BAGAN SERAI.xlsm): per-size sections with
 * NAME1 NAME2 NAME3 / NO1 NO2 NO3 columns, 3 players per row, plus a
 * size-summary column and order header. The design team feeds this to
 * their jersey layout workflow.
 */
export function downloadDesignerExcel(job: Job, order: Order): void {
  const rows: (string | number | null)[][] = []

  rows.push(['MPG PRINTING - DESIGNER NAME LIST'])
  rows.push(['JOB CODE', job.code])
  rows.push(['ORDER', order.number])
  rows.push(['CUSTOMER', order.agent?.name ?? ''])
  rows.push(['PRODUCTION DATE', order.production_date, null, 'ETD', order.expected_completion_date])
  rows.push([])

  for (const item of order.items ?? []) {
    const spec = item.spec ?? {}
    const title = [item.product, spec.collar_type, spec.sleeve_type].filter(Boolean).join(' - ')

    rows.push([title.toUpperCase()])

    // size summary column, like the Excel's "List order" block (S-7 / M-12 / Jumlah)
    const sizeSummary = Object.entries(item.size_matrix).map(([size, qty]) => `${size} - ${qty}`)
    rows.push(['SIZE SUMMARY', sizeSummary.join('   '), null, 'JUMLAH', `${item.qty} helai`])
    rows.push([])

    const personalizations = item.personalizations ?? []
    if (personalizations.length === 0) {
      rows.push(['(no name & number personalization for this item)'])
      rows.push([])
      continue
    }

    const bySize = new Map<string, typeof personalizations>()
    for (const p of personalizations) {
      const key = p.size || 'NO SIZE'
      if (!bySize.has(key)) bySize.set(key, [])
      bySize.get(key)!.push(p)
    }

    for (const [size, players] of bySize) {
      rows.push([`SAIZ ${size}`])
      rows.push(['NAME1', 'NAME2', 'NAME3', 'NO1', 'NO2', 'NO3'])
      for (let i = 0; i < players.length; i += 3) {
        const chunk = players.slice(i, i + 3)
        rows.push([
          chunk[0]?.name ?? '',
          chunk[1]?.name ?? '',
          chunk[2]?.name ?? '',
          chunk[0]?.number ?? '',
          chunk[1]?.number ?? '',
          chunk[2]?.number ?? '',
        ])
      }
      rows.push([])
    }

    rows.push(['REMARK: PASTIKAN NAMA DAN NUMBER PADA BAJU KENA SAMA, CONTOH NAME 1 DAN NO 1'])
    rows.push([])
  }

  const sheet = XLSX.utils.aoa_to_sheet(rows)
  sheet['!cols'] = [{ wch: 18 }, { wch: 18 }, { wch: 18 }, { wch: 8 }, { wch: 12 }, { wch: 8 }]

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, sheet, 'NAME LIST')
  XLSX.writeFile(workbook, `${job.code}-names.xlsx`)
}
